import React from "react";
import Grid from "@material-ui/core/Grid";

import styles from "./styles";
import * as Config from "../../helper/Configs";

export default function ResortGrid(props) {
	const classes = styles();
    const { index, grid } = props;
	return (
        <>
        {grid &&
            <Grid item sm={6} md={index == 0 ? "4" : index == 1 ? "3" : index == 2 ? "5" : index == 3 ? "4" : index == 4 ? "3" : "5"}
                className={`${classes.activityItem} ${grid.type == "background-color" ? "color" : "image"} `}
                style={grid.type == "background-color" ? { backgroundColor: `${grid.content}` } : { backgroundImage: `url(${Config.MEDIA_URL}images/${grid.content})` }}
            >
                <div className={index == 4 ? "h1" : "h2"}>{grid.title}</div>
                <div>{grid.description}</div>
            </Grid>
        }
    </>
	);
}
